import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import BlueprintCourse from "./routes/BlueprintCourse";

export default store => ({
  path: "blueprint-courses",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "blueprint-courses" */ "./components/BlueprintCoursesWrapper"
      ),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [BlueprintCourse(store)],
});
